"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadList = void 0;
class LoadList {
    constructor(currentPoele, materialTypes, materials) {
        this.currentPoele = currentPoele;
        this.materialTypes = materialTypes;
        this.materials = materials;
    }
}
exports.LoadList = LoadList;
//# sourceMappingURL=loadList.js.map